"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerContribRegistry = void 0;
var PlayerContribRegistry = /** @class */ (function () {
    function PlayerContribRegistry() {
        this._cache = {};
    }
    PlayerContribRegistry.get = function (player) {
        player.__contrib__ = player.__contrib__ || {};
        player.__contrib__.services =
            player.__contrib__.services || new PlayerContribRegistry();
        return player.__contrib__.services;
    };
    PlayerContribRegistry.prototype.get = function (token) {
        var result = this._cache[token];
        if (!result) {
            throw new Error("cannot find resource with token ".concat(token));
        }
        return result;
    };
    PlayerContribRegistry.prototype.register = function (token, creator) {
        var requestedResource = this._cache[token];
        if (!requestedResource) {
            requestedResource = this._cache[token] = {
                instance: creator(),
            };
        }
        return requestedResource.instance;
    };
    return PlayerContribRegistry;
}());
exports.PlayerContribRegistry = PlayerContribRegistry;
//# sourceMappingURL=player-contrib-registry.js.map